import { Assembly, AssemblyVotingSummary } from './assemblies';

/** Realtime channel carrying the live updates of a single assembly. */
export const assemblyChannel = (id: string | number) => `public:assembly.${id}`;

/** Fired whenever attendance or a vote changes the assembly summary. Payload: AssemblyVotingSummary. */
export const ASSEMBLY_SUMMARY_UPDATED = 'assembly.attendance_voting.summary.updated';

/**
 * The summary payload is a subset of Assembly, so only the fields it actually carries are replaced.
 * Note it holds no `can_*` flags and no file data, those still need a fetch (see view.tsx).
 */
export const mergeVotingSummary = (prev: Assembly, summary: AssemblyVotingSummary): Assembly => ({
	...prev,
	status: summary.status,
	translated_status: summary.translated_status,
	assembly_quorum_percentage: summary.assembly_quorum_percentage,
	assembly_quorum_percentage_data: summary.assembly_quorum_percentage_data,
	decisions: summary.decisions,
});

/** A payload missing these would render NaN percentages, so the page refetches instead of merging. */
export const isValidVotingSummary = (summary?: AssemblyVotingSummary): summary is AssemblyVotingSummary =>
	!!summary && Array.isArray(summary.decisions) && !!summary.assembly_quorum_percentage_data;
